module.exports = __webpack_public_path__ + "static/media/hero-handyman.583c6b61.jpg";